<template>
    <div ref="captchaContainer" class="frc-captcha" />
</template>

<script>
import { ref, onMounted, onBeforeUnmount } from "vue";

export default {
  props: ["sitekey"],
  emits: ["done", "error"],

  setup(props, { emit }) {
    const captchaContainer = ref(null);
    let widget = null;

    onMounted(() => {
      const fc = window.friendlyChallenge;

      if (!fc) {
        console.error("FriendlyCaptcha script not loaded");
        return;
      }

      widget = new fc.WidgetInstance(captchaContainer.value, {
        sitekey: props.sitekey,
        doneCallback: (solution) => emit("done", solution),
        errorCallback: (err) => emit("error", err),
      });
    });

    onBeforeUnmount(() => widget?.destroy());

    return { captchaContainer };
  },
};
</script>
